import { defineStore } from "pinia";
export const useDarkMode = defineStore({
    id: "dark-mode",
    state: () => ({
        isDarkMode: window.document.documentElement.classList.contains("dark"),
    }),
    actions: {
        resetDarkMode() {
            localStorage.removeItem("theme");
            if (window.matchMedia("(prefers-color-scheme:dark)").matches) {
                window.document.documentElement.classList.add("dark");
                this.isDarkMode = true;
            }
            else {
                window.document.documentElement.classList.remove("dark");
                this.isDarkMode = false;
            }
        },
        toggleDarkMode() {
            const method = this.isDarkMode ? "remove" : "add";
            window.document.documentElement.classList[method]("dark");
            localStorage.theme = !this.isDarkMode ? "dark" : "light";
            this.isDarkMode = !this.isDarkMode;
        },
    },
});
